<!-- <div class="question-skip" *ngIf="showSkip">
<label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
  <input
    type="checkbox"
    [checked]="skipped"
    [(ngModel)]="skipped"
    (ngModelChange)="onSkipChange()"
    name="add-note-toggle"
    id="skip-driver-details-toggle">
    <span class="custom-toggle__indi"></span>
    <span class="custom-toggle__label">Skip for now</span>
  </label>
</div> -->
@if (showParent) {
  @if (showSkip) {
    <div class="question-skip">
      <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
        <input
          type="checkbox"
          name="skip-toggle"
          [(ngModel)]="skip"
          [checked]="skip"
          (ngModelChange)="onSkipChange()">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">Skip for now</span>
        </label>
      </div>
    }
    <div id="skip-section" [ngClass]="{'disabled': skip}">
      <div class="question-pull">
        <div class="card card--freedom">
          <div class="card-body">
            <div class="card__content">
              @if (showLabel) {
                <div class="mb-20">
                  <h5>{{question.question_prompt}}</h5>
                </div>
              }
              @for (child of childrenQuestions; track child; let i = $index) {
                <app-question-controller
                  [question]="child"
                  [showLabel]="true"
                  [showLabelQuestionCopy]="true"
                  (questionAnswer)="onQuestionChange($event)">
                </app-question-controller>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }


  @if (!showParent) {
    @if (showLabel && (question?.question_copy || question?.email_version)) {
      <label class="form-group__label">
        {{question?.question_copy || question?.email_version}}
      </label>
    }
    @for (child of itemQuestions; track child; let i = $index) {
      <div class="form-group">
        <app-question-controller
          [question]="child"
          [showLabel]="true"
          [damageModalNarrow]="true"
          [showLabelQuestionCopy]="true"
          (questionAnswer)="onQuestionChange($event)">
        </app-question-controller>
      </div>
    }
  }
